import React from 'react';
import IconBase from 'react-icons/IconBase';

export const CodeSandboxIcon = props => (
  <IconBase viewBox="0 0 32 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.78 0L2 7.84V23.95L16 32L30 23.95V7.84L15.78 0ZM14.25 28.73L8.82 25.69V20.56L3.75 17.63V10.88L14.25 16.76V28.73ZM15.78 13.5L5.72 7.62L11.19 4.57L15.78 7.21L20.59 4.57L26.06 7.62L15.78 13.5ZM28.25 17.63L23.73 20.44V25.47L17.97 28.73V16.76L28.25 11.1V17.63Z"
      fill="white"
    />
  </IconBase>
);
